module.exports = __webpack_public_path__ + "img/rolling10ex_icon.8578f6bc.png";